import React from "react";
import { DfpAd } from "../dfp-ad/";
import "./dfp-ad-horizontal.m.css";

export function DFPAdsHorizontal() {
  return (
    <div styleName="dfp" className="adBox-300x250">
      <DfpAd adtype="NH_HP_728x90" />
    </div>
  );
}
